
import Fatrows from "../../../assets/outline/Fatrows.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FatrowsIcon({ className, dataTestid = "FatrowsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Fatrows data-testid={dataTestid} className={classes} {...rest} />
  );
}
